module.exports = __webpack_public_path__ + "static/media/ams-success-img-purplish-blue.9f45395a.png";